import { getRoomTag } from '../../../../../../modules/room-tag-storage';

const PACKAGE_PER_PERSON_SLUG = 'package-per-person';

// Arrival room tag (room_tag_v7 cookie) -> event offer definition slugs relevant to that tag (TM-7852).
// The first slug is the offer the tag owns in the event_offer_definitions_room_tags mapping and starts
// expanded. Tags absent here (incl. generic party and private dining) show all offers.
const WEDDING_OFFERS = ['wedding', 'asian-wedding', 'engagement-drinks', 'filming-and-photography', 'outdoor'];
const MEETING_OFFERS = ['meeting', 'conference', 'corporate-hospitality'];
const CONFERENCE_OFFERS = ['conference', 'meeting', 'corporate-hospitality'];
const CORPORATE_OFFERS = ['corporate-hospitality', 'conference', 'meeting'];
const BIRTHDAY_OFFERS = ['birthday', 'outdoor', 'children-party'];
const KIDS_OFFERS = ['children-party', 'birthday', 'outdoor'];
const ENGAGEMENT_OFFERS = ['engagement-drinks', 'wedding', 'outdoor'];

const RELEVANT_OFFER_SLUGS_BY_ARRIVAL_TAG = {
  wedding: WEDDING_OFFERS,
  'outdoor-wedding': WEDDING_OFFERS,
  'unusual-wedding': WEDDING_OFFERS,
  'wedding-ceremonies': WEDDING_OFFERS,
  'wedding-reception': WEDDING_OFFERS,
  'civil-ceremony-venues': WEDDING_OFFERS,
  'civil-partnership': WEDDING_OFFERS,
  'marquee-wedding': WEDDING_OFFERS,
  'unique-wedding': WEDDING_OFFERS,
  'garden-wedding': WEDDING_OFFERS,
  'gay-wedding': WEDDING_OFFERS,
  'asian-weddings': ['asian-wedding', 'wedding', 'engagement-drinks', 'filming-and-photography', 'outdoor'],
  meeting: MEETING_OFFERS,
  boardroom: MEETING_OFFERS,
  classroom: MEETING_OFFERS,
  'computer-room': MEETING_OFFERS,
  'creative-space': MEETING_OFFERS,
  'market-research': MEETING_OFFERS,
  'off-site': MEETING_OFFERS,
  'team-building': MEETING_OFFERS,
  'training-room': MEETING_OFFERS,
  workshop: ['meeting', 'conference'],
  conference: CONFERENCE_OFFERS,
  'academic-venues': CONFERENCE_OFFERS,
  agm: CONFERENCE_OFFERS,
  'awards-ceremony': CONFERENCE_OFFERS,
  breakout: CONFERENCE_OFFERS,
  convention: CONFERENCE_OFFERS,
  'pr-event': CONFERENCE_OFFERS,
  presentation: CONFERENCE_OFFERS,
  'press-conference': CONFERENCE_OFFERS,
  'product-launch': CONFERENCE_OFFERS,
  seminar: CONFERENCE_OFFERS,
  symposium: CONFERENCE_OFFERS,
  'corporate-event': CORPORATE_OFFERS,
  'corporate-party': CORPORATE_OFFERS,
  'corporate-reception': CORPORATE_OFFERS,
  'company-fun-day': CORPORATE_OFFERS,
  'leaving-party': CORPORATE_OFFERS,
  networking: CORPORATE_OFFERS,
  'office-party': CORPORATE_OFFERS,
  'staff-party': CORPORATE_OFFERS,
  'wrap-party': CORPORATE_OFFERS,
  'christmas-party': ['christmas'],
  'christmas-dinner': ['christmas'],
  'xmas-party': ['christmas'],
  'holiday-party': ['christmas'],
  'birthday-party': BIRTHDAY_OFFERS,
  '30th-birthday-party': BIRTHDAY_OFFERS,
  '40th-birthday-party': BIRTHDAY_OFFERS,
  '50th-birthday-party': BIRTHDAY_OFFERS,
  'kids-party': KIDS_OFFERS,
  'childrens-party': KIDS_OFFERS,
  'childrens-birthday-party': KIDS_OFFERS,
  'kids-birthday-party': KIDS_OFFERS,
  'baby-shower': ['baby-shower'],
  'bridal-shower': ['bridal-shower', 'hen-party'],
  'hen-party': ['hen-party', 'bridal-shower'],
  'engagement-party': ENGAGEMENT_OFFERS,
  'engagement-drinks': ENGAGEMENT_OFFERS,
};

// The stylesheet zeroes the border via .c-pricing-table__day:last-child, which still matches a hidden last row.
function removeBottomBorderOfLastVisibleRow(rows, hiddenRows) {
  const lastVisibleRow = rows.filter(row => !hiddenRows.includes(row)).at(-1);
  const lastVisibleRowHeader = lastVisibleRow
    ?.querySelector('.c-pricing-table__row--header .c-pricing-table__row-inner');
  if (lastVisibleRowHeader) {
    lastVisibleRowHeader.style.border = '0';
  }
}

// Mirrors arrival via ?event-offer=<slug>: the tag's own offer starts expanded. Runs before
// roompage.pricing.js inits the table component, which then adopts the expanded row as its active one.
function expandMostRelevantOffer(section, relevantRows, mostRelevantSlug) {
  if (section.querySelector('.c-pricing-table__day--expanded')) {
    return;
  }

  const row = relevantRows.find(relevantRow => relevantRow.dataset.offerSlug === mostRelevantSlug);
  if (!row) {
    return;
  }

  row.classList.add('c-pricing-table__day--expanded');
  row.querySelector('.c-pricing-table__body').style.display = 'block';
}

export function initRelevantOffers() {
  const section = document.querySelector('[data-relevant-offers-enabled]');
  if (!section) {
    return;
  }

  const relevantSlugs = RELEVANT_OFFER_SLUGS_BY_ARRIVAL_TAG[getRoomTag()];
  if (!relevantSlugs) {
    return;
  }

  const rows = [...section.querySelectorAll('[data-offer-slug]')];
  const themedRows = rows.filter(row => row.dataset.offerSlug !== PACKAGE_PER_PERSON_SLUG);
  const relevantRows = themedRows.filter(row => relevantSlugs.includes(row.dataset.offerSlug));
  if (!relevantRows.length) {
    return;
  }

  const hiddenRows = themedRows
    .filter(row => !relevantRows.includes(row) && !row.classList.contains('c-pricing-table__day--expanded'));
  hiddenRows.forEach(row => {
    row.style.display = 'none';
  });

  removeBottomBorderOfLastVisibleRow(rows, hiddenRows);

  expandMostRelevantOffer(section, relevantRows, relevantSlugs[0]);
}
